'use client';
import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { cx } from 'cva';
import { MdCheck } from 'react-icons/md';

const UiCheckbox = React.forwardRef(({ className, error, ...props }, ref) => {
  const hasError = Boolean(error);
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cx(
        'peer h-4 w-4 shrink-0 rounded border border-input ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary',
        hasError ? 'border-error' : 'data-[state=checked]:border-primary',
        className
      )}
      {...props}>
      <CheckboxPrimitive.Indicator
        className={cx(
          'flex items-center justify-center text-white font-semibold'
        )}>
        <MdCheck className="h-4 w-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
UiCheckbox.displayName = CheckboxPrimitive.Root.displayName;

function Checkbox(props) {
  const { onChange, ...rest } = props;

  const handleValueChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  return <UiCheckbox onCheckedChange={handleValueChange} {...rest} />;
}

export default Checkbox;
